const GET_VERTICALS = "GET_VERTICALS";
const GET_VERTICALS_SUCCESS = "GET_VERTICALS_SUCCESS";
const GET_VERTICALS_FAILURE = "GET_VERTICALS_FAILURE";
const CLEAR_GET_VERTICALS = "CLEAR_GET_VERTICALS";

const verticalSymbols = {
  GET_VERTICALS_SUCCESS,
  GET_VERTICALS_FAILURE,
  GET_VERTICALS,
  CLEAR_GET_VERTICALS,
};
export default verticalSymbols;
